(function () {
  function initCollectionSort() {
    var sortRoot = document.querySelector('[data-collection-sort]');
    if (!sortRoot || sortRoot.dataset.sortReady === 'true') return;
    sortRoot.dataset.sortReady = 'true';

    var sortTrigger = sortRoot.querySelector('[data-sort-trigger]');
    var sortMenu = sortRoot.querySelector('[data-sort-menu]');
    var sortValue = sortRoot.querySelector('[data-sort-value]');
    var sortOptions = sortRoot.querySelectorAll('[data-sort-option]');
    var url = new URL(window.location.href);
    var currentSort = url.searchParams.get('sort_by') || sortRoot.getAttribute('data-current-sort') || 'best-selling';

    if (!url.searchParams.has('sort_by') && !sortRoot.hasAttribute('data-skip-default-redirect')) {
      url.searchParams.set('sort_by', 'best-selling');
      window.location.replace(url.toString());
      return;
    }

    sortOptions.forEach(function (optionBtn) {
      var isCurrent = optionBtn.getAttribute('data-value') === currentSort;
      optionBtn.classList.toggle('is-selected', isCurrent);
      optionBtn.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
      if (isCurrent && sortValue) {
        sortValue.textContent = optionBtn.textContent.trim();
      }
    });

    function closeSortMenu() {
      sortRoot.classList.remove('is-open');
      sortMenu.hidden = true;
      sortTrigger.setAttribute('aria-expanded', 'false');
    }

    function openSortMenu() {
      sortRoot.classList.add('is-open');
      sortMenu.hidden = false;
      sortTrigger.setAttribute('aria-expanded', 'true');
    }

    sortTrigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (sortMenu.hidden) {
        openSortMenu();
      } else {
        closeSortMenu();
      }
    });

    sortOptions.forEach(function (optionBtn) {
      optionBtn.addEventListener('click', function () {
        var nextValue = optionBtn.getAttribute('data-value') || 'best-selling';
        var nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('sort_by', nextValue);
        window.location.assign(nextUrl.toString());
      });
    });

    document.addEventListener('click', function (event) {
      if (!sortRoot.contains(event.target)) closeSortMenu();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSortMenu();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionSort);
  } else {
    initCollectionSort();
  }
})();
